import { Icon } from 'components/Icon';
import { Image } from 'components/Image';
import { Money } from 'components/Money';
import { Text } from 'components/Text';
import { SaleItemViewer } from 'components/saleItem/SaleItemViewer';
import { useModal } from 'components/modal/ModalStack';
import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { getProductPrice, getProductTitle } from '../StoreProposedOptions';
import { BLOCK_HEADER_SIZES, imageSources } from 'helpers/mediaSources';
import { saleItemHasViewerContent } from '../saleItemViewerContent';
import { StoreQuantityStepper } from './StoreQuantityStepper';
import './StoreProductBlockHeader.scss';
import { getPromotionPrice } from 'helpers/promotionPrice';
/**
 * @component StoreProductBlockHeader
 * @since 1.0.0
 */
export function StoreProductBlockHeader(props) {
    var _a, _b, _c;
    const { hasDirectSales, item, lang, quantity, onQuantityChange, hideQuantity } = props;
    function applyQuantity(next) {
        onQuantityChange === null || onQuantityChange === void 0 ? void 0 : onQuantityChange(Math.max(1, next));
    }
    const modal = useModal();
    const translation = (_a = item.translations) === null || _a === void 0 ? void 0 : _a.find((entry) => entry.language.code === lang);
    const promoPrice = getPromotionPrice(item.price, item.promotions);
    const showPrice = hasDirectSales && item.configuration === 'FINISHED';
    const showInfo = saleItemHasViewerContent(item, lang);
    /**
     * @function onSaleItemDetail
     * @since 1.0.0
     * @hidden
     */
    function onSaleItemDetail() {
        modal.present({
            title: getProductTitle(item, lang) || item.sku,
            picto: '',
            className: 'deal-sale-item-selector-item-modal',
            modal: React.createElement(SaleItemViewer, { item: item, lang: lang, isStore: true })
        });
    }
    const className = classNames('store-product-block-header', props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "store-product-block-header__image" }, ((_b = item.image) === null || _b === void 0 ? void 0 : _b.image) && (React.createElement(Image, Object.assign({ lazy: true }, imageSources(item.image.image, BLOCK_HEADER_SIZES))))),
        React.createElement("div", { className: "store-product-block-header__body" },
            React.createElement("div", { className: "store-product-block-header__title-row" },
                React.createElement(Text, { value: getProductTitle(item, lang), className: "store-product-block-header__title" }),
                showInfo && (React.createElement("button", { type: "button", className: "store-product-block-header__info", "aria-label": t('View details'), onClick: onSaleItemDetail },
                    React.createElement(Icon, { value: "circle-info" })))),
            React.createElement(Text, { html: true, value: (_c = translation === null || translation === void 0 ? void 0 : translation.summary) !== null && _c !== void 0 ? _c : item.summary, className: "store-product-block-header__description" }),
            React.createElement("div", { className: "store-product-block-header__meta" },
                showPrice && !hideQuantity && (React.createElement("div", { className: "store-product-block-header__price-block" }, promoPrice !== null ? (React.createElement(React.Fragment, null,
                    React.createElement(Money, { value: item.price, className: "store-product-block-header__price--original" }),
                    React.createElement(Money, { value: promoPrice, className: "store-product-block-header__price--promo" }))) : (React.createElement(Money, { value: getProductPrice(item), className: "store-product-block-header__price" })))),
                !hideQuantity && (React.createElement(StoreQuantityStepper, { value: quantity, onChange: applyQuantity }))))));
}
